module.exports = __webpack_public_path__ + "media/images/athletes/2028-e34ec90c6213159c95e166316f3995c7.png";